import React from "react";
import { HiOutlineTemplate } from "react-icons/hi";
import { space, color } from "styled-system";
import styled from "styled-components";

const StyledIcon = styled(HiOutlineTemplate).attrs((props) => ({
  size: props.size,
}))((props) => props.styles, space, color);

const MyAllstarIcon = (props) => {
  return <StyledIcon {...props} />;
};

MyAllstarIcon.defaultProps = {
  size: 22,
  styles: {},
};

export default MyAllstarIcon;
